import React from 'react'
import { path } from 'ramda'
import { Query } from 'react-apollo'
import { getSignedData } from './query'
import { withTheme } from 'styled-components'
import UploadResume from './UploadResume'

export const UploadResumeQuery = (props) => (
  <Query query={getSignedData}>
    {({ data, loading, error, refetch }) => {
      if (loading) return <p>Loading...</p>
      if (error) return <p>Error</p>
      if (data) {
        return <UploadResume
          url={path(['s3PostPolicy', 'url'], data)}
          fields={path(['s3PostPolicy', 'fields'], data)}
          dispatch={props.dispatch}
          jobId={props.jobId}
          refetch={refetch}
          error={props.error}
          setUploadingFile={props.setUploadingFile}
        />
      }
    }}
  </Query>
)

export default withTheme(UploadResumeQuery)
